// src/contexto/CategoriasContext.jsx
import { createContext, useContext, useState, useCallback } from "react";
import { listarCategoriasGastoUseCase } from "../../../core/gastos/application/listarCategoriasGasto.usecase.js";

const GastosCategoriasContext = createContext(null);

export const useGastosCategorias = () => {
  const ctx = useContext(GastosCategoriasContext);
  if (!ctx) {
    throw new Error(
      "[useGastosCategorias] debe usarse dentro de GastosCategoriasProvider"
    );
  }
  return ctx;
};

export function GastosCategoriasProvider({ children }) {
  const [categorias, setCategorias] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  const listarCategorias = useCallback(async () => {
    setCargando(true);
    setError(null);

    try {
      const data = await listarCategoriasGastoUseCase();
      setCategorias(data);
      return data;
    } catch (e) {
      setError(e.message || "Error al listar categorías");
      throw e;
    } finally {
      setCargando(false);
    }
  }, []);

  return (
    <GastosCategoriasContext.Provider
      value={{
        categorias,
        cargando,
        error,
        listarCategorias,
      }}
    >
      {children}
    </GastosCategoriasContext.Provider>
  );
}